export default __webpack_public_path__ + "static/media/img4.47d02a5e.png";